/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CostAttribute {
  DEDUCTIBLE = 'DEDUCTIBLE',
  OOP_MAX = 'OOP_MAX',
  EMPLOYEE_MONTHLY_CONTRIBUTION = 'EMPLOYEE_MONTHLY_CONTRIBUTION',
}
